import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import HitEventBadge from './HitEventBadge';

const HitFeed = ({ hits, awayAbbr, homeAbbr, onPlayerClick, limit = 20 }) => {
  const displayed = [...hits].reverse().slice(0, limit);

  if (!displayed.length) {
    return (
      <div className="flex items-center justify-center py-10 text-[#658d71] text-xs uppercase tracking-widest">
        No hits recorded yet
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1 max-h-[380px] overflow-y-auto pr-1">
      <AnimatePresence initial={false}>
        {displayed.map((hit, i) => {
          const isHR = hit.event === 'Home Run';
          const side = hit.isTop ? awayAbbr : homeAbbr;
          return (
            <motion.div
              key={`${hit.batterId}-${hit.inning}-${hit.event}-${i}`}
              initial={{ opacity: 0, x: -12 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 12 }}
              transition={{ duration: 0.18 }}
              className={`flex items-start gap-2.5 p-2.5 border transition-all ${
                isHR
                  ? 'border-[#c4333e] bg-[rgba(196,51,62,0.08)]'
                  : 'border-[rgba(101,141,113,0.35)] bg-[rgba(0,0,0,0.08)]'
              }`}
            >
              <div className="shrink-0 flex flex-col items-center gap-0.5 w-10">
                <span className="text-[8px] font-bold text-[#658d71] uppercase tracking-widest">
                  {hit.isTop ? '▲' : '▼'}{hit.inning}
                </span>
                <span className="text-[8px] font-bold text-[#a9c9b1] uppercase">{side}</span>
              </div>

              <HitEventBadge event={hit.event} />

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <button
                    onClick={() => hit.batterId && onPlayerClick?.(hit.batterId, hit.batter)}
                    className="text-[11px] font-black uppercase tracking-wide text-white hover:text-[#d8ceb3] transition-colors truncate"
                  >
                    {hit.batter.split(' ').pop()}
                  </button>
                  {hit.rbi > 0 && (
                    <span className="text-[9px] bg-[#c4333e] text-white px-1.5 py-0.5 font-black">
                      {hit.rbi} RBI
                    </span>
                  )}
                  <span className="ml-auto text-[9px] text-[#658d71] font-bold tabular-nums shrink-0">
                    {hit.awayScore}–{hit.homeScore}
                  </span>
                </div>
                <p className="text-[9px] text-[#a9c9b1] leading-tight mt-0.5 line-clamp-1">
                  {hit.description}
                </p>
                {(hit.exitVelocity || hit.distance || hit.launchAngle) && (
                  <div className="flex gap-2 mt-1 flex-wrap">
                    {hit.exitVelocity && (
                      <span className="text-[8px] text-[#658d71] font-bold uppercase tracking-widest">
                        EV: <span className="text-[#a9c9b1]">{Math.round(hit.exitVelocity)} mph</span>
                      </span>
                    )}
                    {hit.launchAngle && (
                      <span className="text-[8px] text-[#658d71] font-bold uppercase tracking-widest">
                        LA: <span className="text-[#a9c9b1]">{Math.round(hit.launchAngle)}°</span>
                      </span>
                    )}
                    {hit.distance && (
                      <span className="text-[8px] text-[#658d71] font-bold uppercase tracking-widest">
                        DIST: <span className="text-[#a9c9b1]">{Math.round(hit.distance)} ft</span>
                      </span>
                    )}
                  </div>
                )}
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};

export default HitFeed;